<template>
    <b-dropdown id="dropdown-1" :text="currentStatusText" class="m-md-2">
        <b-dropdown-item v-if="workflow.status != 1" @click="openDialog('active')">{{ $t('active') }}</b-dropdown-item>
        <b-dropdown-item v-if="workflow.status != 2" @click="openDialog('disable')">{{ $t('disable') }}</b-dropdown-item>
        <b-dropdown-item v-if="workflow.status != 3" @click="openDialog('delete')">{{ $t('delete') }}</b-dropdown-item>
    </b-dropdown>
</template>
<script>
export default {
    props: {
        workflow: Object
    },
    methods: {
        openDialog(action) {

            var self = this;
            this.$store.commit('openDialog', {
                title: this.$t('are-you-sure'),
                content: this.$t(`${action}-{e}-warning`, { e: this.$t('workflow') }),
                cancelBtn: true,
                confirmCallBack: function () {
                    self.handleWorkflow(action)
                }
            })
        },
        handleWorkflow(action) {

            if (action === 'active') this.workflow.status = 1;
            if (action === 'disable') this.workflow.status = 2;
            if (action === 'delete') this.workflow.status = 3;

            this.$store.commit('showBlockingSpinner');

            this.$cfetch(`${this.$settings.APIBaseURL}/workflows/save`, {
                method: 'POST',
                data: this.workflow,

            }).then(res => {
                if (res.status !== 'SUCCESS') throw new Error('Unexpected error ')

                this.$store.commit('hideBlockingSpinner');
                this.$router.replace("/settings/workflows")

            }).catch(err => {
                this.$log.error.call(this, err)
                this.$store.commit('openDialog', {
                    title: this.$t('something-went-wrong'),
                    content: this.$t(`error-${action}-{e}`, { e: this.$t('workflow') }),
                })
            }).finally(() => {
                this.selectedTag = undefined
            })
        }
    },
    computed: {
        currentStatusText() {
            if (this.workflow.status == 1) return this.$t('active');
            if (this.workflow.status == 2) return this.$t('disabled');
            if (this.workflow.status == 3) return this.$t('deleted');
            return ''
        }
    }
}
</script>